<form #form="ngForm">
  <div class="row flex-column">
    <div class="col-12">
      <ng-container *ngIf="!soloValores">
        <plex-text [label]="params?.titulo" [html]="true" [(ngModel)]="registro.valor" name="observaciones"
                   [required]="params?.required" [qlToolbar]="qlToolbar"> </plex-text>
      </ng-container>

      <p *ngIf="soloValores" class="readonly">
        <span [innerHTML]="registro.valor"></span>
      </p>
    </div>
  </div>
</form>
<div *ngIf="!soloValores" class="boton-historial">
  <plex-button (click)="verHistorial = !verHistorial"
               size="sm" type="primary" class="collapse-card"
               label="{{ !verHistorial ? 'Ver historial' : 'Ocultar historial' }}">
  </plex-button>
</div>
<section *ngIf="!isLoading && verHistorial && historial.length > 0"
         class="mx-4 d-flex flex-column justify-content-between h-100">
  <div *ngFor="let item of historial" class="historial-item">
    <div class="historial-fecha">
      {{ item.fecha | date:'dd/MM/yyyy hh:mm a' }}
    </div>

    <div class="historial-texto" [innerHTML]="decodeHtml(item.registro.valor)">
    </div>
  </div>


</section>
<div *ngIf="isLoading && verHistorial">Cargando historial...</div>
<div *ngIf="!isLoading && verHistorial && historial.length === 0">
  <em>No hay evoluciones previas registradas</em>
</div>